var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGgoo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#ECECEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_1157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2294 16.8087C15.2602 17.7237 13.8851 18.2761 12.0846 18.2761C9.77405 18.2761 7.68832 16.9015 6.66504 14.8975L8.69624 13.3037C9.16693 14.7777 10.5061 15.8411 12.0846 15.8411C12.968 15.8411 13.6818 15.6206 14.232 15.2414L16.2294 16.8087Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51574 12.1385C8.51574 12.5458 8.57913 12.9378 8.69624 13.3043L6.66504 14.8982C6.24152 14.0685 6 13.131 6 12.1385C6 11.146 6.24152 10.2085 6.66512 9.37891L8.69624 10.9728C8.57913 11.3394 8.51574 11.7312 8.51574 12.1385Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2158 7.64606L14.4913 9.34593C13.8782 8.77862 13.052 8.43502 12.0845 8.43502C10.506 8.43502 9.16685 9.49834 8.69616 10.9724L6.66504 9.37854C7.68824 7.37455 9.77397 6 12.0845 6C13.7641 6 15.1869 6.62476 16.2158 7.64606Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 12.1385C17.9999 12.5716 17.9689 12.9942 17.9064 13.402C17.6992 14.7549 17.1457 15.9442 16.2293 16.8093L14.2319 15.2419C14.8633 14.8068 15.2794 14.1624 15.4901 13.402H12.1658V11.1279H17.9273C17.9752 11.4567 17.9999 11.7942 17.9999 12.1385Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_1157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12.2763,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGgoo);
export default __webpack_public_path__ + "static/media/ggoo.5bb7f76a90de2158058db7df25a28824.svg";
export { ForwardRef as ReactComponent };